module.exports = __webpack_public_path__ + "static/media/15.269146a3.jpg";